<template>
  <div class="stage-settlement-msg">
    <ul class="list">
      <li>消费总额：￥{{ initAmount }}<span v-show="wholesalePrice*1 > 0" style="color: #f56c6c;">{{ wholesalePrice*1 > 0 ? (' (包含货款'+(wholesalePrice*1).toFixed(2)+'元)') : '' }}</span></li>
      <li v-if="editPriceVal != 1">
        优惠金额： -￥
        <span v-text="(couponMoney()*1+changeDiscountMoney*1+memberDiscountMoney*1+orderChangeMoney*1+buyGiftDiscount*1+fullGiftDiscount*1+activityMoney()*1).toFixed(2)"></span>
        <el-tooltip v-if="buyGiftDiscount || fullGiftDiscount || editMoneyVal || changeDiscountMoney || memberDiscountMoney || orderChangeMoney || (data.others ? (data.others.couponMsg.money || data.others.jifenMsg.money || data.others.fenBiMsg.money || activityPriceList.length > 0) ? true : false : false)" effect="light" class="item" content="Right Bottom 提示文字" placement="right-end">
          <div slot="content">
            <p v-if="editPriceVal != 1 && editMoneyVal">整单改价优惠：-￥{{ toFixeds(editMoneyVal) }}</p>
            <p v-show="orderChangeMoney">整单改价优惠：-￥ {{ toFixeds(orderChangeMoney) }}</p>
            <p v-show="changeDiscountMoney">改价优惠：-￥{{ toFixeds(changeDiscountMoney) }}</p>
            <p v-show="memberDiscountMoney">会员优惠：-￥{{ toFixeds(memberDiscountMoney) }}</p>
            <p v-show="buyGiftDiscount">买赠活动：-￥{{ toFixeds(buyGiftDiscount) }}</p>
            <p v-show="fullGiftDiscount">满赠活动：-￥{{ toFixeds(fullGiftDiscount) }}</p>
            <!--6.1-->
            <p v-show="data.others ? (data.others.couponMsg.money * 1 > 0) ? true : false : false">优惠券抵扣：-￥{{ data.others ? data.others.couponMsg ? toFixeds(data.others.couponMsg.money) : '0.00' : '0.00' }}</p>
            <p v-show="data.others ? (data.others.jifenMsg.money * 1 > 0) ? true : false : false">积分抵扣：-￥{{ data.others ? data.others.jifenMsg ? toFixeds(data.others.jifenMsg.money) : '0.00' : '0.00' }}</p>
            <p v-show="data.others ? (data.others.fenBiMsg.money * 1 > 0) ? true : false : false">粉币抵扣：-￥{{ data.others ? data.others.fenBiMsg ? toFixeds(data.others.fenBiMsg.money) : '0.00' : '0.00' }}</p>
            <p v-for="(v,n) in activityPriceList" :key="n">{{ v.activityType == 1 ? '特价促销' : '定时打折' }}：-￥{{ v.price }}</p>
          </div>
          <i class="iconfont" style="margin-left: 5px;">&#xe71a;</i>
        </el-tooltip>
      </li>
      <li v-else>优惠金额： -￥{{ discountAmount }}</li>
      <li v-if="isPartPay == 1 && customerMsg.phone && editPriceVal == 1">已还款项：￥{{ (partPayTotal*1-data.totalMoney*1).toFixed(2) }}</li>
      <li v-if="editPriceVal != 1">
        应收金额：￥
        <span v-text="receivableHandle()"></span>
        <span v-if="editMoneyVal > 0" class="editPriced">已改价</span>
        <el-popover v-if="isOrderEditPrice == 1" placement="right-start" width="300" trigger="hover">
          <div class="editPrice">
            <h4>改价</h4>
            <h5>订单改价后，所涉及的项目、商品有员工提成的将不受影响，将按照商家后台设置提成方案统计</h5>
            <el-input v-model.trim="editMoney" class="editInput" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{2})[\d+\.]/g, '')" type="number" placeholder="请输入金额" @keyup.enter.native="Lib.keyboardBlur">
              <template slot="prepend">￥</template>
            </el-input>
            <div class="newFootBtn">
              <el-button type="primary" @click="comfirmEditPrice">确 定</el-button>
              <el-button @click="cancelEditPrice">取 消</el-button>
            </div>
          </div>
          <i slot="reference" class="iconfont" style="color: ##A1A4A9;font-size: 16px;">&#xe625;</i>
        </el-popover>
      </li>
      <li v-if="isPartPay == 1 && customerMsg.phone">
        实收金额：
        <el-input v-model.trim="amountReceived" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{2})[\d+\.]/g, '')" style="width: 220px;margin-right: 20px;" :min="0" type="number" placeholder="请输入实收金额" @keyup.enter.native="Lib.keyboardBlur()"></el-input>
        剩余：
        <span class="red-number themeFC">
          ￥<samp v-text="surplusAmount"></samp>
        </span>
      </li>
      <li v-else>
        实收金额：
        <span class="red-number themeFC">
          ￥<samp v-text="amountReceived"></samp>
        </span>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    settlementMsg: {
      type: String,
      default: ''
    },
    customerMsg: {
      type: Object,
      default: Object
    },
    changeCoupon: {
      type: Boolean
    },
    editPriceVal: {
      type: Number,
      default: Number
    },
    buyGiftDiscount: {
      type: Number,
      default: Number
    },
    fullGiftDiscount: {
      type: Number,
      default: Number
    },
    changeDiscountMoney: {
      type: Number,
      default: Number
    },
    memberDiscountMoney: {
      type: Number,
      default: Number
    },
    orderChangeMoney: {
      type: Number,
      default: Number
    },
    partPayTotal: {
      type: Number,
      default: Number
    },
    initAmount: {
      type: Number,
      default: Number
    },
    wholesalePrice: {
      type: Number,
      default: Number
    },
    activityPriceList: {
      type: Array,
      default: Array
    },
    packageBuy: {
      type: Number,
      default: Number
    },
    discountAmount: {
      type: String,
      default: String
    }
  },
  data() {
    return {
      data: {},
      amountReceived: '0.00',
      surplusAmount: '0.00',
      isPartPay: window.sessionStorage.isPartPay || 0,
      isOrderEditPrice: window.sessionStorage.isOrderEditPrice || 0,
      editMoney: '',
      editMoneyVal: 0,
      receivableMoney: ''
    };
  },
  watch: {
    settlementMsg() {
      this.data = window.JSON.parse(this.settlementMsg);
      if (this.settlementMsg) {
        const data = window.JSON.parse(this.settlementMsg);
        if (data.others) {
          if (data.resulteMoney * 1 == 0) {
            this.amountReceived = '0.00';
            return;
          }
          this.amountReceived = data.resulteMoney * 1;
        } else {
          this.amountReceived = data.resulteMoney * 1;
        }
      } else {
        this.amountReceived = (this.data.totalMoney * 1) - (this.data.resulteMoney * 1) - (this.editMoneyVal * 1);
      }
    },
    amountReceived() {
      this.changeAmountReceived();
    },
    changeCoupon() {
      this.editMoney = '';
      this.editMoneyVal = 0;
      this.surplusAmount = 0;
      this.changeAmountReceived();
    }
  },
  activated() {
    this.editMoney = '';
    this.editMoneyVal = 0;
    setTimeout(() => {
      this.isPartPay = window.sessionStorage.isPartPay;
      this.isOrderEditPrice = window.sessionStorage.isOrderEditPrice;
    }, 1000);
  },
  methods: {
    // 应收金额
    receivableHandle() {
      this.receivableMoney = (this.data.totalMoney * 1 - this.packageBuy * 1 - (this.data.others ? this.data.others.couponMsg ? (this.data.others.couponMsg.money * 1) : 0 : 0) - (this.data.others ? this.data.others.jifenMsg ? (this.data.others.jifenMsg.money * 1) : 0 : 0) - (this.data.others ? this.data.others.fenBiMsg ? (this.data.others.fenBiMsg.money * 1) : 0 : 0)).toFixed(2);
      return (this.receivableMoney - this.editMoneyVal * 1).toFixed(2);
    },
    // 确认改价
    comfirmEditPrice() {
      if (this.wholesalePrice * 1 > 0) {
        this.$message('此单有拿货价不允许改价');
        this.editMoneyVal = 0;
        return;
      }
      if ((this.editMoney * 1) > (this.receivableMoney * 1)) {
        this.$message('改价金额需要小于应收金额');
        this.editMoneyVal = 0;
      } else if (!this.editMoney) {
        this.editMoneyVal = 0;
      } else {
        this.editMoneyVal = ((this.receivableMoney * 1) - (this.editMoney * 1)).toFixed(2);
      }
      this.surplusAmount = 0;
      this.changeAmountReceived('editPrice');
    },
    // 取消改价
    cancelEditPrice() {
      this.editMoney = '';
      this.editMoneyVal = 0;
      this.changeAmountReceived('editPrice');
    },
    // 修改实收金额
    changeAmountReceived(val) {
      // this.Lib.keyboardBlur()
      const data = window.JSON.parse(this.settlementMsg);
      if ((this.amountReceived * 1) > (data.resulteMoney * 1 + this.surplusAmount * 1)) {
        if (val !== 'editPrice') {
          this.$message(`实收金额需要小于等于${((data.resulteMoney * 1) + (this.surplusAmount * 1)).toFixed(2)}元`);
        }
        this.amountReceived = ((data.resulteMoney * 1) + (this.surplusAmount * 1)).toFixed(2);
        return;
      } if (this.amountReceived === '' || this.amountReceived === null || this.amountReceived === undefined) {
        this.amountReceived = 0;
      } else if (val === 'editPrice') {
        this.amountReceived = (this.data.totalMoney * 1 - this.packageBuy * 1 - this.editMoneyVal * 1 - (this.data.others ? this.data.others.couponMsg ? (this.data.others.couponMsg.money * 1) : 0 : 0) - (this.data.others ? this.data.others.jifenMsg ? (this.data.others.jifenMsg.money * 1) : 0 : 0) - (this.data.others ? this.data.others.fenBiMsg ? (this.data.others.fenBiMsg.money * 1) : 0 : 0)).toFixed(2);
      }
      if (this.data.others) {
        if (this.editPriceVal == 1) {
          this.surplusAmount = this.toFixeds((data.totalMoney * 1) - (this.amountReceived * 1));
          this.$emit('getSettlementMsg', this.putParentData());
        } else {
          this.surplusAmount = this.toFixeds((data.totalMoney * 1) - (data.others.couponMsg ? (data.others.couponMsg.money * 1) : 0) - (data.others.jifenMsg ? (data.others.jifenMsg.money * 1) : 0) - (data.others.fenBiMsg ? (data.others.fenBiMsg.money * 1) : 0) - (this.amountReceived * 1) - (this.editMoneyVal * 1) - (this.packageBuy * 1));
          this.$emit('getSettlementMsg', this.putParentData());
        }
      } else {
        this.surplusAmount = this.toFixeds((data.totalMoney * 1) - (this.amountReceived * 1));
        this.$emit('getSettlementMsg', this.putParentData());
      }
    },
    // 传递信息给父组件
    putParentData() {
      const data = window.JSON.parse(this.settlementMsg);
      if (this.data.others) {
        return {
          editMoneyVal: window.JSON.parse(window.JSON.stringify(this.editMoneyVal)),
          resulteMoney: window.JSON.parse(window.JSON.stringify(this.amountReceived)),
          couponMsg: window.JSON.parse(window.JSON.stringify(data.others.couponMsg)),
          jifenMsg: window.JSON.parse(window.JSON.stringify(data.others.jifenMsg)),
          fenBiMsg: window.JSON.parse(window.JSON.stringify(data.others.fenBiMsg))
        };
      }
      return {
        editMoneyVal: window.JSON.parse(window.JSON.stringify(this.editMoneyVal)),
        resulteMoney: window.JSON.parse(window.JSON.stringify(this.amountReceived)),
        couponMsg: 0,
        jifenMsg: 0,
        fenBiMsg: 0
      };
    },
    // 保留两位小数
    toFixeds(num) {
      if (num * 1 > 0) {
        return (num * 1).toFixed(2);
      }
      return '0.00';
    },
    couponMoney() {
      if (!this.settlementMsg) {
        return '0.00';
      }
      const data = window.JSON.parse(this.settlementMsg);
      if (data.others) {
        return this.toFixeds((this.editMoneyVal ? (this.editMoneyVal * 1) : 0) + (data.others.couponMsg ? (data.others.couponMsg.money * 1) : 0) + (data.others.jifenMsg ? (data.others.jifenMsg.money * 1) : 0) + (data.others.fenBiMsg ? (data.others.fenBiMsg.money * 1) : 0));
      }
      return '0.00';
    },
    activityMoney() {
      let total = 0;
      this.activityPriceList.forEach((a) => {
        total += a.price * 1;
      });
      return total;
    }
  }
};
</script>
<!-- 结算信息-->
<style lang="less" scoped>
.stage-settlement-msg {
  font-size: 14px;
  color: #333333;
  padding-bottom: 20px;
  .list {
    li {
      list-style-type: none;
      height: auto;
      line-height: 36px;
      i {
        color: #d2d2d2;
        font-size: 14px;
        display: inline-block;
      }
      .editPriced {
        color: #67c23a;
        border: 1px solid #f0f9eb;
        font-size: 14px;
        padding: 4px;
      }
    }
  }
  .red-number {
    font-size: 20px;
  }
}
.editPrice {
  padding: 10px;
  h4 {
    font-size: 16px;
    font-weight: 700;
    height: 20px;
    line-height: 20px;
    color: #333333;
  }
  h5 {
    padding: 5px 0 10px 0;
    font-size: 13px;
    color: #666;
    height: 40px;
    line-height: 20px;
  }
  .editInput {
    width: 220px;
  }
  .newFootBtn {
    padding: 10px 0;
    text-align: right;
  }
}
</style>
